import React, { useState } from 'react';
import "../assets/css/quote.css";
import Covers from './ChildComp/Covers';
import QuoteCard from './ChildComp/QuoteCard';
import Loader from './ChildComp/Loader';
import { useLocation } from 'react-router-dom';
import { useSharedDataContext } from './SharedDataContext';
import { useEffect } from 'react';
import { centralCall } from '../api';
import EditDetailsModal from './ChildComp/EditDetailsModal';
import { Modal } from "react-bootstrap";
import { CommaSeprator, isObjEmpty } from './utility/utilityFunction';
import PlanDetails from './ChildComp/PlanDetails';
import { BsStars } from "react-icons/bs";
import { FaRegFilePdf } from "react-icons/fa6";
import html2pdf from "html2pdf.js";


const Quote = () => {
    const [insurers, setInsurers] = useState([]);
    const { sharedData, setSharedData, setSharedQuoteData , showToast} = useSharedDataContext();
    const SIOptions = [10000, 20000, 30000, 50000, 100000, 200000, 500000];
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();
    const responseData = location.state;
    const [selectedSI, setSelectedSI] = useState("10000");
    const [addonCovers, setAddonCovers] = useState({});
    const [emergencyDropdown, setEmergencyDropdown] = useState("0");
    const [vetDropdown, setVetDropdown] = useState("0");
    const [vetAmount, setVetAmount] = useState("0");
    const [isOpenEditDetailModal, setOpenEditDetailModal] = useState(false);
    const [isOpenPlanDetailsModal, setOpenPlanDetailsModal] = useState(false);
    const [petDetailsObj, setPetDetailsObj] = useState({});
    const [ownerDetailsObj, setOwnerDetailsObj] = useState({});
    const [isCopiedText, setCopiedText] = useState(false);
    const [hiddenQuotes, setHiddenQuotes] = useState([]);
    const [downloadQuotePDF, setDownloadQuotePDF] = useState(false);
    const handleSIChange = (event) => {
        setSelectedSI(event.target.value);
        setSharedData(prev=>({ ...prev, SumInsured: event.target.value }))

    }
    const handleAddonCoverChange = (updatedAddonCovers) => {
        setAddonCovers(updatedAddonCovers);
    };
    const handleEmergencyDropdownChange = (value) => {
        setEmergencyDropdown(value);
    };

    const handleVetDropdownChange = (value) => {
        setVetDropdown(value);
    };

    const handleVetAmountChange = (value) => {
        setVetAmount(value);
    };
    const constructQuoteModel = () => {


        const addonsSelected = {
            ...sharedData.AddonsSelected,
            "EmergencyPetMindingCoverDays": sharedData?.EmergencyPetMindingCoverDays,
            "VeteneryConsultationOrDoctorOnCallCoverDays": sharedData?.VeteneryConsultationOrDoctorOnCallCoverDays,
            "VeteneryConsultationOrDoctorOnCallCoverAmount": sharedData?.VeteneryConsultationOrDoctorOnCallCoverAmount
        };
        const petDetails = {
            "PetName": sharedData.petname,
            "BreedCategory": sharedData.breedCategory,
            "Breed": sharedData.petbreed,
            "Age": (parseInt(sharedData.petage.split(' ')[0]) * 12 + parseInt(sharedData?.petagemonth?.split(' ').length >1 ? sharedData?.petagemonth?.split(' ')[0] : 0)),
            "Gender": sharedData.petgender,
            "Weight": sharedData.petweight,
            "SumInsured": !sharedData.SumInsured ? selectedSI : sharedData.SumInsured,
            "AddonsSelected": addonsSelected
        };


        return {
            "MobileNo": sharedData.mobileno,
            "LeadSource": "pet",
            "ClientId": 0,
            "UserId": 0,
            "EnquiryNo": sharedData.enquiryno,
            "PetDetails": [petDetails]
        };
    };


    const getUpdatedDetails = (updatedData) => {
        const { petDetailsObj, ownerDetailsObj } = updatedData;
        setPetDetailsObj(petDetailsObj);
        setOwnerDetailsObj(ownerDetailsObj);
        setOpenEditDetailModal(false);
    }

    useEffect(() => {
        callQuote();
    }, [sharedData.AddonsSelected, sharedData.SumInsured, petDetailsObj, ownerDetailsObj, emergencyDropdown, vetDropdown, vetAmount]);

  


    const callQuote = async () => {
        try {
            setIsLoading(true);
            setInsurers([]);
            const quotemodel = constructQuoteModel();
            centralCall({ URL: "/api/Quotation/GetQuotation", Request: quotemodel, IsPost: true })
                //fetchQuote(quotemodel)
                .then(Res => {
                    setSharedData(prevData => ({
                        ...prevData,
                        SumInsured: !sharedData.SumInsured ? selectedSI : sharedData.SumInsured,
                        /*EmergencyPetMindingCoverDays: emergencyDropdown,
                        VeteneryConsultationOrDoctorOnCallCoverDays: vetDropdown,
                        VeteneryConsultationOrDoctorOnCallCoverAmount: vetAmount*/


                    }));
                    if (Res.status === 200 && Res.data.StatusCode === "200" && Res.data.Data.QuoteSuccess === true) {
                        //setInsurers(prv=> ([...prv, data.data.Data]));
                        const QuoteRes = Res.data.Data.PetQuotationDetails.map(row => ({ ...row, InsurerID: Res.data?.Data?.InsurerID }));
                        //console.log({ QuoteRes });
                        setInsurers(QuoteRes);
                    }
                        setIsLoading(false);
                });


        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const RemoveAddonFromQuoteCard = (addonName) => {
        let covers = { ...addonCovers, [addonName]: !addonCovers[addonName] };
        setAddonCovers(covers);
    }

    const quotationSorting = (sortingOrder) => {
        let sortedQuotations = insurers?.sort((a, b) => sortingOrder === 'asc' ? a.TotalPremium - b.TotalPremium : b.TotalPremium - a.TotalPremium);
        setInsurers(sortedQuotations);
    }


    useEffect(() => {


        setAddonCovers(sharedData?.AddonsSelected);
        setEmergencyDropdown(sharedData?.EmergencyPetMindingCoverDays);
        setVetDropdown(sharedData?.VeteneryConsultationOrDoctorOnCallCoverDays);
        setVetAmount(sharedData?.VeteneryConsultationOrDoctorOnCallCoverAmount)

    }, []);



    const handleCopy = (content) => {
        navigator.clipboard.writeText(content).then(() => {
            setCopiedText(true);
            setTimeout(() => {
                setCopiedText(false);
            }, 3000);
        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    };


    const hideQuotes = (insurerId) => {
        if (hiddenQuotes.length === 0) {
            showToast({ message:"You can not hide all the quotes", flag:'warning',duration: 3000});
        } else {
        setHiddenQuotes([...hiddenQuotes, insurerId]);
        }
    }

    const showPlanDetail = (InsurerID) => {
        sessionStorage.removeItem('sharedQuoteData');
        setOpenPlanDetailsModal(true);
        let selectedQuote = insurers?.find(row => row.InsurerID === InsurerID);

        setSharedQuoteData(selectedQuote);
    }


    const generateQuotePDF = async() => {
        setDownloadQuotePDF(true);
        let element = document.getElementById('quotePDF');
        /*const editBtn = document.getElementById('editBtn');
        if (editBtn) editBtn.remove();*/
        let option = {
            margin: 0,
            filename: (sharedData.enquiryno || '').replace('/', '_') + "_Quotation" + "_Summary.pdf",
            image: { type: 'jpeg', quality: 1 },
            html2canvas: { scale: 8, letterRendering: true, useCORS: true, dpi: 192 },
            jsPDF: { unit: 'in', format: 'a4', orientation: 'l', putOnlyUsedFonts: true },
            enableLinks: true,
            height: element.scrollHeight,
            // pagebreak: { mode: 'avoid-all', before: '.part2break' }
        }

        try {

            await html2pdf().set(option).from(element).save();
            setDownloadQuotePDF(false);

        } catch (error) {
            console.log({ error });
        }
    }

    return (
        <>
            {downloadQuotePDF ? <div className="IsDownlodPDF"><span class="PDFloader"></span> <span class="PDFloaderText">Generating PDF</span></div> : ""}
        <div className="Quotes" id="quotePDF">
            <div className="container">
                <div className="PetInsuranceQuote">
                    <div className="PI_EditDeta PI_EditDeta2 ">
                            <ul>
                                <li>
                                    <img src={require("../assets/images/user.svg").default} alt="" />
                                    <span className="fw-bold text-capitalize">{sharedData.ownername}</span>
                                </li>
                                <li>
                                    <img src={require("../assets/images/mobile.svg").default} alt="" />
                                    <span>{sharedData.mobileno}</span>
                                </li>
                                <li>
                                    <img src={require("../assets/images/dog.svg").default} alt="" />
                                    <span className="fw-bold text-capitalize">{sharedData.petname}</span>
                                </li>
                                <li>
                                    <img src={require("../assets/images/location.svg").default} alt="" />
                                    <span>{sharedData.pincode}</span>
                                </li>
                            </ul>
                        <div  className="EditVehicleDet" id='editBtn' onClick={() => setOpenEditDetailModal(true)}>
                            <img src={require("../assets/images/Edit.svg").default} alt="" />
                           Edit
                        </div>
                    </div>
                    <div className="PI_EditDeta SameForm">
                        <div className="PetInput">
                            <select className="InputBox" value={sharedData.SumInsured} onChange={handleSIChange}>
                                {SIOptions.map((option, index) => (
                                    <option key={index} value={option}>
                                        ₹{CommaSeprator(option)}
                                    </option>
                                ))}
                            </select>
                            <label>Cover Value</label>
                        </div>
                        <div className="SortPlan">
                            <img src={require("../assets/images/short.svg").default} alt="" />
                            <div className="PetInput">
                                <select className="InputBox sortSection" onChange={e => quotationSorting(e.target.value)}>
                                    <option value="asc">Premium Ascending</option>
                                    <option value="dsc">Premium Descending</option>
                                </select>
                                <label>Sort Plan</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="CallRequest">
                    <button onClick={generateQuotePDF} className="showOpt" id="MoreOption">
                        <span><BsStars /></span>
                        <span><FaRegFilePdf /></span>
                        <span>Generate PDF</span>
                    </button>
                </div>
            </div>

            <div className="container mt-4">
                <div className="row">
                    <div className="col-md-3">
                        <Covers onAddonCoverChange={handleAddonCoverChange} onEmergencyDropdownChange={handleEmergencyDropdownChange}
                            onVetDropdownChange={handleVetDropdownChange}
                            onVetAmountChange={handleVetAmountChange} />
                    </div>
                    <div className="col-md-9">
                        <div className="ExclusiveGSTRow">
                            <div className="">
                                <h3><span>{insurers.length}</span><span></span><span>&nbsp;</span> Plan for your pet</h3>
                                <p>Prices Exclusive of GST</p>
                            </div>
                            <div className="MobileEdit text-end">
                                <div className="MobileShareOpt">
                                    {/*<button className="shareButton" data-target="#shareModel" data-toggle="modal" value="Share Quotes"><i className="fab fa-whatsapp"></i><span className="SQText">&nbsp;Share Quotes</span></button>*/}
                                    <p>
                                        <span>
                                            Lead ID:
                                            <strong className="ng-binding">
                                                <span>{sharedData.enquiryno}&nbsp; {isCopiedText ? <span>Copied!!!</span> : <i className="far fa-copy " onClick={() => handleCopy(sharedData.enquiryno)}></i>}</span>
                                            </strong>
                                        </span>
                                    </p>
                                </div>
                            </div>
                           
                        </div>
                        <div>
                            {isLoading && (<Loader />)}
                        </div>
                        {!isLoading && insurers.filter(r => !hiddenQuotes.includes(r.InsurerID)).map((insurer, index) => (
                            <QuoteCard key={index} quoteData={insurer}
                                RemoveAddonFromQuoteCard={RemoveAddonFromQuoteCard}
                                HideQuotes={hideQuotes}
                                sharedData={sharedData}
                                showPlanDetail={showPlanDetail}
                            />
                        ))}
                    </div>
                </div>
            </div>
            {hiddenQuotes.length > 0 && <small className="ClearQuote" onClick={() => setHiddenQuotes([])}>{/*<i className="far fa-times-circle"></i> */}Show {hiddenQuotes.length} Hidden {hiddenQuotes.length === 1 ? "Quote" : "Quotes"}</small>}
            {isOpenEditDetailModal &&
                <Modal show={isOpenEditDetailModal} className="customeName" >
                    <EditDetailsModal getUpdatedDetails={getUpdatedDetails} onClose={() => setOpenEditDetailModal(false)} />
                </Modal>
            }
            {
                isOpenPlanDetailsModal &&
                <Modal show={isOpenPlanDetailsModal} className="customeName EditProductPremium " >
                        <PlanDetails onClose={() => setOpenPlanDetailsModal(false)} />
                    </Modal>
            }
            </div>
        </>
    );
}
export default Quote;
